/*
 * SearchForm is Shrine's class, from js.shrinetheme.com main.js, which the W3 loader only runs after the
 * shopper's first interaction. This file is a plain deferred script and always ran first, so the class
 * line below threw "SearchForm is not defined" on every /search view and <main-search> was never
 * defined. It is defined once Shrine has registered its search-form element - main.js does that on
 * the line right after its SearchForm class. Without main.js it stays undefined, as before.
 * Dawn's phone scroll-on-focus is left out: it scrolled the box up under the sticky header.
 */
customElements.whenDefined('search-form').then(function () {
  if (typeof SearchForm === 'undefined' || customElements.get('main-search')) return;

  class MainSearch extends SearchForm {
    constructor() {
      super();
      this.allSearchInputs = document.querySelectorAll('input[type="search"]');
      this.setupEventListeners();
    }

    setupEventListeners() {
      let allSearchForms = [];
      this.allSearchInputs.forEach(input => allSearchForms.push(input.form))
      if (allSearchForms.length < 2) return;
      allSearchForms.forEach(form =>
        form.addEventListener('reset', this.onFormReset.bind(this))
      );
      this.allSearchInputs.forEach(input =>
        input.addEventListener('input', this.onInput.bind(this))
      );
    }

    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) {
        this.keepInSync('', this.input);
      }
    }

    onInput(event) {
      const target = event.target;
      this.keepInSync(target.value, target);
    }

    keepInSync(value, target) {
      this.allSearchInputs.forEach(input => {
        if (input !== target) {
          input.value = value;
        }
      });
    }
  }


  customElements.define('main-search', MainSearch);
});
